export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Mã', align: 'start', value: 'code', width: '12rem',
      filter: value => {
                  if ( !filters.find(x=>x.name === 'code')?.value) return true
                  return value.includes(filters.find(x=>x.name === 'code')?.value)
      }
  },
  // { text: 'Alias', align: 'start', value: 'alias', width: '20rem',  
  //     filter: value => {
  //       if ( !filters.find(x=>x.name === 'alias')?.value) return true
  //       return value.includes(filters.find(x=>x.name === 'alias')?.value)
  //     }
  // },
  { text: 'Tên', align: 'start', value: 'name', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'name')?.value) return true
        return value.includes(filters.find(x=>x.name === 'name')?.value)
      }
  },
  
  { text: 'Slug', align: 'start', value: 'slug', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'slug')?.value) return true
        return value.includes(filters.find(x=>x.name === 'slug')?.value)
      }
  },
  
  { text: 'Tên nhóm', align: 'start', value: 'groupName', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'groupName')?.value) return true
        return value.includes(filters.find(x=>x.name === 'groupName')?.value)
      }
  },
  
  { text: 'Nhóm slug', align: 'start', value: 'groupSlug', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'groupSlug')?.value) return true
        if ( !value) return true
        return value.includes(filters.find(x=>x.name === 'groupSlug')?.value)
      }
  },
  
  { text: 'Parent', align: 'start', value: 'parentCode', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'parentCode')?.value) return true
        return value.includes(filters.find(x=>x.name === 'parentCode')?.value)
      }
  },
]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const finalHeaders = [
  {text: '', value: 'actions', width: 100},
  { text: 'Tháng', align: 'start', value: 'month', width: '7rem' },
  { text: 'Chưa hoàn tất NVM', align: 'start', value: 'incompleteNvm' },
  { text: 'Hoàn tất NVM', align: 'start', value: 'completeNvm' },
  { text: 'Tổng phiếu NVM', align: 'start', value: 'totalReviewNvm' },
  { text: 'Chưa hoàn tất COT2', align: 'start', value: 'incompleteCot2' },
  { text: 'Hoàn tất COT2', align: 'start', value: 'completeCot2' },
  { text: 'Tổng phiếu COT2', align: 'start', value: 'totalReviewCot2' },
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]